import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function MoneyBag({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M8.13085 1.34634C7.89349 1.29887 7.64905 1.38378 7.49224 1.56818C7.33543 1.75258 7.29089 2.00749 7.37589 2.23414L8.53811 5.33339H9.96211L9.04546 2.889L9.63377 3.00666C10.7558 3.23106 11.9111 3.23106 13.0331 3.00666L13.6214 2.889L12.7048 5.33339H14.1288L15.291 2.23414C15.376 2.00749 15.3314 1.75258 15.1746 1.56818C15.0178 1.38378 14.7734 1.29887 14.536 1.34634L12.7716 1.69922C11.8222 1.8891 10.8446 1.8891 9.89526 1.69922L8.13085 1.34634Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        d="M10.6668 19.2094V20.6667H12.0001V10.0001H10.6668V11.4118C10.1181 11.4986 9.59089 11.6584 9.15277 11.8965C8.56921 12.2136 8.00011 12.7601 8.00011 13.5683C8.00011 14.5437 8.62416 15.1239 9.30782 15.4633C9.71293 15.6645 10.1894 15.8089 10.6668 15.9256V17.8504C10.4151 17.7954 10.1804 17.7272 9.97435 17.6489C9.72377 17.5536 9.54071 17.453 9.42417 17.3625C9.33967 17.2969 9.31605 17.2574 9.31242 17.2513C9.31305 17.253 9.31442 17.2576 9.31612 17.2649L8.01742 17.5668C8.10529 17.9447 8.35845 18.223 8.60634 18.4155C8.86109 18.6134 9.17392 18.771 9.50065 18.8952C9.85306 19.0292 10.2511 19.1352 10.6668 19.2094ZM10.6668 14.5478V12.7665C10.3241 12.837 10.0227 12.9412 9.78933 13.0681C9.39592 13.2818 9.33344 13.4712 9.33344 13.5683C9.33344 13.8381 9.45939 14.05 9.90073 14.2691C10.1183 14.3771 10.3762 14.4668 10.6668 14.5478Z"
        fill={iconColor}
      />
      <Path
        d="M15.3334 17.1895C15.3334 18.113 14.7236 18.6858 14.0392 18.983C13.8195 19.0784 13.5817 19.1516 13.3334 19.2059V17.8262C13.395 17.8059 13.4534 17.7838 13.5082 17.76C13.8994 17.5901 14.0001 17.3985 14.0001 17.1895C14.0001 17.0142 13.9238 16.8352 13.4575 16.6271C13.4174 16.6092 13.3761 16.5918 13.3334 16.575V15.1681C13.5689 15.2382 13.7947 15.3175 14.001 15.4095C14.6597 15.7036 15.3334 16.2323 15.3334 17.1895Z"
        fill={iconColor}
      />
      <Path
        d="M13.3334 12.9817V11.562C13.4075 11.5842 13.4807 11.6081 13.5528 11.6337C14.2545 11.883 14.9314 12.3285 15.2713 13.0593L14.0623 13.6215C13.9495 13.379 13.7118 13.1551 13.3334 12.9817Z"
        fill={iconColor}
      />
      <Path
        d="M14.0001 6.66672H8.66677L4.88722 11.6489C2.77997 14.4266 2.7532 18.2602 4.82144 21.0671C5.5626 22.073 6.73765 22.6667 7.98707 22.6667H16.136C17.3081 22.6667 18.4106 22.1097 19.1059 21.166C21.18 18.3512 20.9936 14.4672 18.6596 11.8639L14.0001 6.66672ZM5.94948 12.4547L9.32887 8.00006H13.4048L17.6669 12.7539C19.5791 14.8868 19.7318 18.0689 18.0325 20.3751C17.5885 20.9777 16.8845 21.3334 16.136 21.3334H7.98707C7.16131 21.3334 6.38469 20.941 5.89485 20.2762C4.17726 17.9452 4.19949 14.7615 5.94948 12.4547Z"
        fill={iconColor}
      />
    </Svg>
  );
}
